import { render, staticRenderFns } from "./censusList.vue?vue&type=template&id=d2a5358c&scoped=true"
import script from "./censusList.vue?vue&type=script&lang=js"
export * from "./censusList.vue?vue&type=script&lang=js"
import style0 from "./censusList.vue?vue&type=style&index=0&id=d2a5358c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a5358c",
  null
  
)

export default component.exports